import { Alert, Button, Flex, Form } from 'antd'
import { FormInstance } from 'antd/lib'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'

import { usePersonsServiceGetPersonListByDataEndpoint } from 'src/api/queries'
import { Countries, Permissions } from 'src/api/requests'
import { message, Text } from 'src/components'
import { useUser } from 'src/hooks'
import { yearMonthDaySlash } from 'src/libs'
import { useLocales } from 'src/locales'

import { AddNewPerson, RegisterType } from './AddNewPerson'

type Props = {
  form?: FormInstance
}

export const AddPersonAlert = ({ form }: Props) => {
  const { t } = useLocales()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { hasPermission } = useUser()
  const params = Form.useWatch([], form)
  const shouldSearchInMConnect = Form.useWatch('shouldSearchInMConnect', form)

  const filteredParams = Object.fromEntries(
    Object.entries(params || {}).filter(([_, value]) => value !== '')
  )

  const onToggle = () => setIsModalOpen((prev) => !prev)

  const birthDate =
    filteredParams.birthDate && dayjs.isDayjs(filteredParams?.birthDate)
      ? filteredParams.birthDate.format(yearMonthDaySlash)
      : undefined

  const { data, isFetching, error } =
    usePersonsServiceGetPersonListByDataEndpoint(
      {
        ...filteredParams,
        shouldSearchInMConnect: true,
        citizenship: Countries.MD,
        birthDate
      },
      [],
      { enabled: false }
    )

  useEffect(() => {
    if (
      !error &&
      shouldSearchInMConnect &&
      !isFetching &&
      !data?.data?.length
    ) {
      message.error(t('persons.no_person_found'))
    }
  }, [data, shouldSearchInMConnect, error, isFetching])

  return (
    <>
      <Form.Item name="shouldSearchInMConnect" hidden />
      <Alert
        type="warning"
        style={{
          padding: '20px 24px'
        }}
        showIcon
        message={
          <Flex align="center" justify="space-between">
            <Text weight={700}>{t('analysis.add_analysis.no_code_found')}</Text>

            <Flex gap={8}>
              {hasPermission(
                Permissions.PERSONS_PERSONS_CREATE_INSTITUTION
              ) && (
                <Button onClick={onToggle}>
                  {t('persons.add_new_person')}
                </Button>
              )}
            </Flex>
          </Flex>
        }
      />

      {isModalOpen && (
        <AddNewPerson
          initialValues={form?.getFieldsValue()}
          initialRegisterType={RegisterType.PERSON}
          onCloseModal={onToggle}
        />
      )}
    </>
  )
}
